export const INVISIBLE_NODE_ID = 'invisible-node';

export const NODE_TYPES = {
  FLOW_STEP: 'flowStep',
  INVISIBLE: 'invisible',
};

export const EDGE_TYPES = {
  ADD_NODE_EDGE: 'addNodeEdge',
};
